import { deselectAllRecordings } from './deselectAllRecordings';

import type { Recording, Store } from '../../../store/list/types';

/**
 * Toggles the select option on recordings.
 */
export const toggleSelectRecordings = (
  store: Store,
  recordingsToBeToggled: Recording[],
  updateRecordingObjects: boolean,
): void => {
  const {
    recordings,
    selectedRecordings,
    selectedAllRecordings,
    setSelectedAllRecordings,
    setSelectedRecordings,
  } = store.getState();

  if (selectedAllRecordings) {
    // If we were previously in select-all mode, we now want to limit to just the current page.
    setSelectedAllRecordings(false);
    // Deselect everything, avoiding pagination-related confusion.
    deselectAllRecordings(store);
    toggleSelectRecordings(
      store,
      // We know we want everything except the given recording to be selected.
      recordings.filter((rec) => recordingsToBeToggled.indexOf(rec) === -1),
      true,
    );
  } else {
    recordingsToBeToggled.forEach((recording) => {
      const selectedRecordingObj = {
        id: recording.id,
        created: recording.created_epoch_time,
      };

      // If we are selecting more than 1 recordings at a time,
      // it means we are programmatically selecting them and not using an event.
      if (updateRecordingObjects) {
        recording.selected = !recording.selected;
      }

      if (recording.selected) {
        selectedRecordings.push(selectedRecordingObj);
      } else {
        const selectedRecordingIndex = selectedRecordings.findIndex(
          (rec) => rec.id === recording.id,
        );
        selectedRecordings.splice(selectedRecordingIndex, 1);
      }
      setSelectedRecordings(selectedRecordings);
    });
  }
};
